export const hintOptionMixin = {
  data() {
    return {
      showHint: false
    }
  }
}
